/* Copyright 2020 Andrew Cuccinello, 2022 Jonas Karlsson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const SCALE_APP_DATA = {
    hitPoints: [
        {
            level: -1,
            high: { minimum: 9, maximum: 10, die: 2 },
            moderate: { minimum: 7, maximum: 8, die: 2 },
            low: { minimum: 5, maximum: 6, die: 2 },
        },
        {
            level: 0,
            high: { minimum: 17, maximum: 20, die: 4 },
            moderate: { minimum: 14, maximum: 16, die: 3 },
            low: { minimum: 11, maximum: 13, die: 3 },
        },
        {
            level: 1,
            high: { minimum: 24, maximum: 26, die: 3 },
            moderate: { minimum: 19, maximum: 21, die: 3 },
            low: { minimum: 14, maximum: 16, die: 3 },
        },
        {
            level: 2,
            high: { minimum: 36, maximum: 40, die: 5 },
            moderate: { minimum: 28, maximum: 32, die: 5 },
            low: { minimum: 21, maximum: 25, die: 5 },
        },
        {
            level: 3,
            high: { minimum: 53, maximum: 59, die: 7 },
            moderate: { minimum: 42, maximum: 48, die: 7 },
            low: { minimum: 31, maximum: 37, die: 7 },
        },
        {
            level: 4,
            high: { minimum: 72, maximum: 78, die: 7 },
            moderate: { minimum: 57, maximum: 63, die: 7 },
            low: { minimum: 42, maximum: 48, die: 7 },
        },
        {
            level: 5,
            high: { minimum: 91, maximum: 97, die: 7 },
            moderate: { minimum: 72, maximum: 78, die: 7 },
            low: { minimum: 53, maximum: 59, die: 7 },
        },
        {
            level: 6,
            high: { minimum: 115, maximum: 123, die: 9 },
            moderate: { minimum: 91, maximum: 99, die: 9 },
            low: { minimum: 67, maximum: 75, die: 9 },
        },
        {
            level: 7,
            high: { minimum: 140, maximum: 148, die: 9 },
            moderate: { minimum: 111, maximum: 119, die: 9 },
            low: { minimum: 82, maximum: 90, die: 9 },
        },
        {
            level: 8,
            high: { minimum: 165, maximum: 173, die: 9 },
            moderate: { minimum: 131, maximum: 139, die: 9 },
            low: { minimum: 97, maximum: 105, die: 9 },
        },
        {
            level: 9,
            high: { minimum: 190, maximum: 198, die: 9 },
            moderate: { minimum: 151, maximum: 159, die: 9 },
            low: { minimum: 112, maximum: 120, die: 9 },
        },
        {
            level: 10,
            high: { minimum: 215, maximum: 223, die: 9 },
            moderate: { minimum: 171, maximum: 179, die: 9 },
            low: { minimum: 127, maximum: 135, die: 9 },
        },
        {
            level: 11,
            high: { minimum: 240, maximum: 248, die: 9 },
            moderate: { minimum: 191, maximum: 199, die: 9 },
            low: { minimum: 142, maximum: 150, die: 9 },
        },
        {
            level: 12,
            high: { minimum: 265, maximum: 273, die: 9 },
            moderate: { minimum: 211, maximum: 219, die: 9 },
            low: { minimum: 157, maximum: 165, die: 9 },
        },
        {
            level: 13,
            high: { minimum: 290, maximum: 298, die: 9 },
            moderate: { minimum: 231, maximum: 239, die: 9 },
            low: { minimum: 172, maximum: 180, die: 9 },
        },
        {
            level: 14,
            high: { minimum: 315, maximum: 323, die: 9 },
            moderate: { minimum: 251, maximum: 259, die: 9 },
            low: { minimum: 187, maximum: 195, die: 9 },
        },
        {
            level: 15,
            high: { minimum: 340, maximum: 348, die: 9 },
            moderate: { minimum: 271, maximum: 279, die: 9 },
            low: { minimum: 202, maximum: 210, die: 9 },
        },
        {
            level: 16,
            high: { minimum: 365, maximum: 373, die: 9 },
            moderate: { minimum: 291, maximum: 299, die: 9 },
            low: { minimum: 217, maximum: 225, die: 9 },
        },
        {
            level: 17,
            high: { minimum: 390, maximum: 398, die: 9 },
            moderate: { minimum: 311, maximum: 319, die: 9 },
            low: { minimum: 232, maximum: 240, die: 9 },
        },
        {
            level: 18,
            high: { minimum: 415, maximum: 423, die: 9 },
            moderate: { minimum: 331, maximum: 339, die: 9 },
            low: { minimum: 247, maximum: 255, die: 9 },
        },
        {
            level: 19,
            high: { minimum: 440, maximum: 448, die: 9 },
            moderate: { minimum: 351, maximum: 359, die: 9 },
            low: { minimum: 262, maximum: 270, die: 9 },
        },
        {
            level: 20,
            high: { minimum: 465, maximum: 473, die: 9 },
            moderate: { minimum: 371, maximum: 379, die: 9 },
            low: { minimum: 277, maximum: 285, die: 9 },
        },
        {
            level: 21,
            high: { minimum: 495, maximum: 505, die: 11 },
            moderate: { minimum: 395, maximum: 405, die: 11 },
            low: { minimum: 295, maximum: 305, die: 11 },
        },
        {
            level: 22,
            high: { minimum: 532, maximum: 544, die: 13 },
            moderate: { minimum: 424, maximum: 436, die: 13 },
            low: { minimum: 317, maximum: 329, die: 13 },
        },
        {
            level: 23,
            high: { minimum: 569, maximum: 581, die: 13 },
            moderate: { minimum: 454, maximum: 466, die: 13 },
            low: { minimum: 339, maximum: 351, die: 13 },
        },
        {
            level: 24,
            high: { minimum: 617, maximum: 633, die: 17 },
            moderate: { minimum: 492, maximum: 508, die: 17 },
            low: { minimum: 367, maximum: 383, die: 17 },
        },
    ],
    abilityScore: [
        { level: -1, extreme: 3, high: 3, moderate: 2, low: 0, terrible: -4, abysmal: -5 },
        { level: 0, extreme: 3, high: 3, moderate: 2, low: 0, terrible: -4, abysmal: -5 },
        { level: 1, extreme: 5, high: 4, moderate: 3, low: 1, terrible: -4, abysmal: -5 },
        { level: 2, extreme: 5, high: 4, moderate: 3, low: 1, terrible: -4, abysmal: -5 },
        { level: 3, extreme: 5, high: 4, moderate: 3, low: 1, terrible: -4, abysmal: -5 },
        { level: 4, extreme: 6, high: 5, moderate: 3, low: 2, terrible: -4, abysmal: -5 },
        { level: 5, extreme: 6, high: 5, moderate: 4, low: 2, terrible: -4, abysmal: -5 },
        { level: 6, extreme: 7, high: 5, moderate: 4, low: 2, terrible: -4, abysmal: -5 },
        { level: 7, extreme: 7, high: 6, moderate: 4, low: 2, terrible: -4, abysmal: -5 },
        { level: 8, extreme: 7, high: 6, moderate: 4, low: 3, terrible: -4, abysmal: -5 },
        { level: 9, extreme: 7, high: 6, moderate: 4, low: 3, terrible: -4, abysmal: -5 },
        { level: 10, extreme: 8, high: 7, moderate: 5, low: 3, terrible: -4, abysmal: -5 },
        { level: 11, extreme: 8, high: 7, moderate: 5, low: 3, terrible: -4, abysmal: -5 },
        { level: 12, extreme: 8, high: 7, moderate: 5, low: 4, terrible: -4, abysmal: -5 },
        { level: 13, extreme: 9, high: 8, moderate: 5, low: 4, terrible: -4, abysmal: -5 },
        { level: 14, extreme: 9, high: 8, moderate: 5, low: 4, terrible: -4, abysmal: -5 },
        { level: 15, extreme: 9, high: 8, moderate: 6, low: 4, terrible: -4, abysmal: -5 },
        { level: 16, extreme: 10, high: 9, moderate: 6, low: 5, terrible: -4, abysmal: -5 },
        { level: 17, extreme: 10, high: 9, moderate: 6, low: 5, terrible: -4, abysmal: -5 },
        { level: 18, extreme: 10, high: 9, moderate: 6, low: 5, terrible: -4, abysmal: -5 },
        { level: 19, extreme: 11, high: 10, moderate: 6, low: 5, terrible: -4, abysmal: -5 },
        { level: 20, extreme: 11, high: 10, moderate: 7, low: 6, terrible: -4, abysmal: -5 },
        { level: 21, extreme: 11, high: 10, moderate: 7, low: 6, terrible: -4, abysmal: -5 },
        { level: 22, extreme: 11, high: 10, moderate: 8, low: 6, terrible: -4, abysmal: -5 },
        { level: 23, extreme: 11, high: 10, moderate: 8, low: 6, terrible: -4, abysmal: -5 },
        { level: 24, extreme: 13, high: 12, moderate: 9, low: 7, terrible: -4, abysmal: -5 },
    ],
    savingThrow: [
        { level: -1, extreme: 9, high: 8, moderate: 5, low: 2, terrible: 0 },
        { level: 0, extreme: 10, high: 9, moderate: 6, low: 3, terrible: 1 },
        { level: 1, extreme: 11, high: 10, moderate: 7, low: 4, terrible: 2 },
        { level: 2, extreme: 12, high: 11, moderate: 8, low: 5, terrible: 3 },
        { level: 3, extreme: 14, high: 12, moderate: 9, low: 6, terrible: 4 },
        { level: 4, extreme: 15, high: 14, moderate: 11, low: 8, terrible: 6 },
        { level: 5, extreme: 17, high: 15, moderate: 12, low: 9, terrible: 7 },
        { level: 6, extreme: 18, high: 17, moderate: 14, low: 11, terrible: 8 },
        { level: 7, extreme: 20, high: 18, moderate: 15, low: 12, terrible: 10 },
        { level: 8, extreme: 21, high: 19, moderate: 16, low: 13, terrible: 11 },
        { level: 9, extreme: 23, high: 21, moderate: 18, low: 15, terrible: 12 },
        { level: 10, extreme: 24, high: 22, moderate: 19, low: 16, terrible: 14 },
        { level: 11, extreme: 26, high: 24, moderate: 21, low: 18, terrible: 15 },
        { level: 12, extreme: 27, high: 25, moderate: 22, low: 19, terrible: 16 },
        { level: 13, extreme: 29, high: 26, moderate: 23, low: 20, terrible: 18 },
        { level: 14, extreme: 30, high: 28, moderate: 25, low: 22, terrible: 19 },
        { level: 15, extreme: 32, high: 29, moderate: 26, low: 23, terrible: 20 },
        { level: 16, extreme: 33, high: 30, moderate: 28, low: 25, terrible: 22 },
        { level: 17, extreme: 35, high: 32, moderate: 29, low: 26, terrible: 23 },
        { level: 18, extreme: 36, high: 33, moderate: 30, low: 27, terrible: 24 },
        { level: 19, extreme: 38, high: 35, moderate: 32, low: 29, terrible: 26 },
        { level: 20, extreme: 39, high: 36, moderate: 33, low: 30, terrible: 27 },
        { level: 21, extreme: 41, high: 38, moderate: 35, low: 32, terrible: 28 },
        { level: 22, extreme: 43, high: 39, moderate: 36, low: 33, terrible: 30 },
        { level: 23, extreme: 44, high: 40, moderate: 37, low: 34, terrible: 31 },
        { level: 24, extreme: 46, high: 42, moderate: 38, low: 36, terrible: 32 },
    ],
    armorClass: [
        { level: -1, extreme: 18, high: 15, moderate: 14, low: 12 },
        { level: 0, extreme: 19, high: 16, moderate: 15, low: 13 },
        { level: 1, extreme: 19, high: 16, moderate: 15, low: 13 },
        { level: 2, extreme: 21, high: 18, moderate: 17, low: 15 },
        { level: 3, extreme: 22, high: 19, moderate: 18, low: 16 },
        { level: 4, extreme: 24, high: 21, moderate: 20, low: 18 },
        { level: 5, extreme: 25, high: 22, moderate: 21, low: 19 },
        { level: 6, extreme: 27, high: 24, moderate: 23, low: 21 },
        { level: 7, extreme: 28, high: 25, moderate: 24, low: 22 },
        { level: 8, extreme: 30, high: 27, moderate: 26, low: 24 },
        { level: 9, extreme: 31, high: 28, moderate: 27, low: 25 },
        { level: 10, extreme: 33, high: 30, moderate: 29, low: 27 },
        { level: 11, extreme: 34, high: 31, moderate: 30, low: 28 },
        { level: 12, extreme: 36, high: 33, moderate: 32, low: 30 },
        { level: 13, extreme: 37, high: 34, moderate: 33, low: 31 },
        { level: 14, extreme: 39, high: 36, moderate: 35, low: 33 },
        { level: 15, extreme: 40, high: 37, moderate: 36, low: 34 },
        { level: 16, extreme: 42, high: 39, moderate: 38, low: 36 },
        { level: 17, extreme: 43, high: 40, moderate: 39, low: 37 },
        { level: 18, extreme: 45, high: 42, moderate: 41, low: 39 },
        { level: 19, extreme: 46, high: 43, moderate: 42, low: 40 },
        { level: 20, extreme: 48, high: 45, moderate: 44, low: 42 },
        { level: 21, extreme: 49, high: 46, moderate: 45, low: 43 },
        { level: 22, extreme: 51, high: 48, moderate: 47, low: 45 },
        { level: 23, extreme: 52, high: 49, moderate: 48, low: 46 },
        { level: 24, extreme: 54, high: 51, moderate: 50, low: 48 },
    ],
    perception: [
        { level: -1, extreme: 9, high: 8, moderate: 5, low: 2, terrible: 0 },
        { level: 0, extreme: 10, high: 9, moderate: 6, low: 3, terrible: 1 },
        { level: 1, extreme: 11, high: 10, moderate: 7, low: 4, terrible: 2 },
        { level: 2, extreme: 12, high: 11, moderate: 8, low: 5, terrible: 3 },
        { level: 3, extreme: 14, high: 12, moderate: 9, low: 6, terrible: 4 },
        { level: 4, extreme: 15, high: 14, moderate: 11, low: 8, terrible: 6 },
        { level: 5, extreme: 17, high: 15, moderate: 12, low: 9, terrible: 7 },
        { level: 6, extreme: 18, high: 17, moderate: 14, low: 11, terrible: 8 },
        { level: 7, extreme: 20, high: 18, moderate: 15, low: 12, terrible: 10 },
        { level: 8, extreme: 21, high: 19, moderate: 16, low: 13, terrible: 11 },
        { level: 9, extreme: 23, high: 21, moderate: 18, low: 15, terrible: 12 },
        { level: 10, extreme: 24, high: 22, moderate: 19, low: 16, terrible: 14 },
        { level: 11, extreme: 26, high: 24, moderate: 21, low: 18, terrible: 15 },
        { level: 12, extreme: 27, high: 25, moderate: 22, low: 19, terrible: 16 },
        { level: 13, extreme: 29, high: 26, moderate: 23, low: 20, terrible: 18 },
        { level: 14, extreme: 30, high: 28, moderate: 25, low: 22, terrible: 19 },
        { level: 15, extreme: 32, high: 29, moderate: 26, low: 23, terrible: 20 },
        { level: 16, extreme: 33, high: 30, moderate: 28, low: 25, terrible: 22 },
        { level: 17, extreme: 35, high: 32, moderate: 29, low: 26, terrible: 23 },
        { level: 18, extreme: 36, high: 33, moderate: 30, low: 27, terrible: 24 },
        { level: 19, extreme: 38, high: 35, moderate: 32, low: 29, terrible: 26 },
        { level: 20, extreme: 39, high: 36, moderate: 33, low: 30, terrible: 27 },
        { level: 21, extreme: 41, high: 38, moderate: 35, low: 32, terrible: 28 },
        { level: 22, extreme: 43, high: 39, moderate: 36, low: 33, terrible: 30 },
        { level: 23, extreme: 44, high: 40, moderate: 37, low: 34, terrible: 31 },
        { level: 24, extreme: 46, high: 42, moderate: 38, low: 36, terrible: 32 },
    ],
    skill: [
        { level: -1, extreme: 8, high: 5, moderate: 4, low: 2, terrible: 1 },
        { level: 0, extreme: 9, high: 6, moderate: 5, low: 3, terrible: 2 },
        { level: 1, extreme: 10, high: 7, moderate: 6, low: 4, terrible: 3 },
        { level: 2, extreme: 11, high: 8, moderate: 7, low: 5, terrible: 4 },
        { level: 3, extreme: 13, high: 10, moderate: 9, low: 7, terrible: 5 },
        { level: 4, extreme: 15, high: 12, moderate: 10, low: 8, terrible: 7 },
        { level: 5, extreme: 16, high: 13, moderate: 12, low: 10, terrible: 8 },
        { level: 6, extreme: 18, high: 15, moderate: 13, low: 11, terrible: 9 },
        { level: 7, extreme: 20, high: 17, moderate: 15, low: 13, terrible: 11 },
        { level: 8, extreme: 21, high: 18, moderate: 16, low: 14, terrible: 12 },
        { level: 9, extreme: 23, high: 20, moderate: 18, low: 16, terrible: 13 },
        { level: 10, extreme: 25, high: 22, moderate: 19, low: 17, terrible: 15 },
        { level: 11, extreme: 26, high: 23, moderate: 21, low: 19, terrible: 16 },
        { level: 12, extreme: 28, high: 25, moderate: 22, low: 20, terrible: 17 },
        { level: 13, extreme: 30, high: 27, moderate: 24, low: 22, terrible: 19 },
        { level: 14, extreme: 31, high: 28, moderate: 25, low: 23, terrible: 20 },
        { level: 15, extreme: 33, high: 30, moderate: 27, low: 25, terrible: 21 },
        { level: 16, extreme: 35, high: 32, moderate: 28, low: 26, terrible: 23 },
        { level: 17, extreme: 36, high: 33, moderate: 30, low: 28, terrible: 24 },
        { level: 18, extreme: 38, high: 35, moderate: 31, low: 29, terrible: 25 },
        { level: 19, extreme: 40, high: 37, moderate: 33, low: 31, terrible: 27 },
        { level: 20, extreme: 41, high: 38, moderate: 34, low: 32, terrible: 28 },
        { level: 21, extreme: 43, high: 40, moderate: 36, low: 34, terrible: 29 },
        { level: 22, extreme: 45, high: 42, moderate: 37, low: 35, terrible: 31 },
        { level: 23, extreme: 46, high: 43, moderate: 38, low: 36, terrible: 32 },
        { level: 24, extreme: 48, high: 45, moderate: 40, low: 38, terrible: 33 },
    ],
    strikeAttack: [
        { level: -1, extreme: 10, high: 8, moderate: 6, low: 4 },
        { level: 0, extreme: 10, high: 8, moderate: 6, low: 4 },
        { level: 1, extreme: 11, high: 9, moderate: 7, low: 5 },
        { level: 2, extreme: 13, high: 11, moderate: 9, low: 7 },
        { level: 3, extreme: 14, high: 12, moderate: 10, low: 8 },
        { level: 4, extreme: 16, high: 14, moderate: 12, low: 9 },
        { level: 5, extreme: 17, high: 15, moderate: 13, low: 11 },
        { level: 6, extreme: 19, high: 17, moderate: 15, low: 12 },
        { level: 7, extreme: 20, high: 18, moderate: 16, low: 13 },
        { level: 8, extreme: 22, high: 20, moderate: 18, low: 15 },
        { level: 9, extreme: 23, high: 21, moderate: 19, low: 16 },
        { level: 10, extreme: 25, high: 23, moderate: 21, low: 17 },
        { level: 11, extreme: 27, high: 24, moderate: 22, low: 19 },
        { level: 12, extreme: 28, high: 26, moderate: 24, low: 20 },
        { level: 13, extreme: 29, high: 27, moderate: 25, low: 21 },
        { level: 14, extreme: 31, high: 29, moderate: 27, low: 23 },
        { level: 15, extreme: 32, high: 30, moderate: 28, low: 24 },
        { level: 16, extreme: 34, high: 32, moderate: 30, low: 25 },
        { level: 17, extreme: 35, high: 33, moderate: 31, low: 27 },
        { level: 18, extreme: 37, high: 35, moderate: 33, low: 28 },
        { level: 19, extreme: 38, high: 36, moderate: 34, low: 29 },
        { level: 20, extreme: 40, high: 38, moderate: 36, low: 31 },
        { level: 21, extreme: 41, high: 39, moderate: 37, low: 32 },
        { level: 22, extreme: 43, high: 41, moderate: 39, low: 33 },
        { level: 23, extreme: 44, high: 42, moderate: 40, low: 35 },
        { level: 24, extreme: 46, high: 44, moderate: 42, low: 36 },
    ],
    strikeDamage: [
        {
            level: -1,
            extreme: { diceCount: 1, diceSize: 6, original: "1d6+1", average: 4.5, bonus: 1 },
            high: { diceCount: 1, diceSize: 4, original: "1d4+1", average: 3.5, bonus: 1 },
            moderate: { diceCount: 1, diceSize: 4, original: "1d4", average: 2.5, bonus: 0 },
            low: { diceCount: 1, diceSize: 4, original: "1d4", average: 2.5, bonus: 0 },
        },
        {
            level: 0,
            extreme: { diceCount: 1, diceSize: 6, original: "1d6+3", average: 6.5, bonus: 3 },
            high: { diceCount: 1, diceSize: 6, original: "1d6+2", average: 5.5, bonus: 2 },
            moderate: { diceCount: 1, diceSize: 4, original: "1d4+2", average: 4.5, bonus: 2 },
            low: { diceCount: 1, diceSize: 4, original: "1d4+1", average: 3.5, bonus: 1 },
        },
        {
            level: 1,
            extreme: { diceCount: 1, diceSize: 8, original: "1d8+4", average: 8.5, bonus: 4 },
            high: { diceCount: 1, diceSize: 6, original: "1d6+3", average: 6.5, bonus: 3 },
            moderate: { diceCount: 1, diceSize: 6, original: "1d6+2", average: 5.5, bonus: 2 },
            low: { diceCount: 1, diceSize: 4, original: "1d4+2", average: 4.5, bonus: 2 },
        },
        {
            level: 2,
            extreme: { diceCount: 1, diceSize: 12, original: "1d12+4", average: 10.5, bonus: 4 },
            high: { diceCount: 1, diceSize: 10, original: "1d10+4", average: 9.5, bonus: 4 },
            moderate: { diceCount: 1, diceSize: 8, original: "1d8+4", average: 8.5, bonus: 4 },
            low: { diceCount: 1, diceSize: 6, original: "1d6+3", average: 6.5, bonus: 3 },
        },
        {
            level: 3,
            extreme: { diceCount: 1, diceSize: 12, original: "1d12+8", average: 14.5, bonus: 8 },
            high: { diceCount: 1, diceSize: 10, original: "1d10+6", average: 11.5, bonus: 6 },
            moderate: { diceCount: 1, diceSize: 8, original: "1d8+6", average: 10.5, bonus: 6 },
            low: { diceCount: 1, diceSize: 6, original: "1d6+5", average: 8.5, bonus: 5 },
        },
        {
            level: 4,
            extreme: { diceCount: 2, diceSize: 10, original: "2d10+7", average: 18, bonus: 7 },
            high: { diceCount: 2, diceSize: 8, original: "2d8+5", average: 14, bonus: 5 },
            moderate: { diceCount: 2, diceSize: 6, original: "2d6+5", average: 12, bonus: 5 },
            low: { diceCount: 2, diceSize: 4, original: "2d4+4", average: 9, bonus: 4 },
        },
        {
            level: 5,
            extreme: { diceCount: 2, diceSize: 12, original: "2d12+7", average: 20, bonus: 7 },
            high: { diceCount: 2, diceSize: 8, original: "2d8+7", average: 16, bonus: 7 },
            moderate: { diceCount: 2, diceSize: 6, original: "2d6+6", average: 13, bonus: 6 },
            low: { diceCount: 2, diceSize: 4, original: "2d4+6", average: 11, bonus: 6 },
        },
        {
            level: 6,
            extreme: { diceCount: 2, diceSize: 12, original: "2d12+10", average: 23, bonus: 10 },
            high: { diceCount: 2, diceSize: 8, original: "2d8+9", average: 18, bonus: 9 },
            moderate: { diceCount: 2, diceSize: 6, original: "2d6+8", average: 15, bonus: 8 },
            low: { diceCount: 2, diceSize: 4, original: "2d4+7", average: 12, bonus: 7 },
        },
        {
            level: 7,
            extreme: { diceCount: 2, diceSize: 12, original: "2d12+12", average: 25, bonus: 12 },
            high: { diceCount: 2, diceSize: 10, original: "2d10+9", average: 20, bonus: 9 },
            moderate: { diceCount: 2, diceSize: 8, original: "2d8+8", average: 17, bonus: 8 },
            low: { diceCount: 2, diceSize: 6, original: "2d6+6", average: 13, bonus: 6 },
        },
        {
            level: 8,
            extreme: { diceCount: 2, diceSize: 12, original: "2d12+15", average: 28, bonus: 15 },
            high: { diceCount: 2, diceSize: 10, original: "2d10+11", average: 22, bonus: 11 },
            moderate: { diceCount: 2, diceSize: 8, original: "2d8+9", average: 18, bonus: 9 },
            low: { diceCount: 2, diceSize: 6, original: "2d6+8", average: 15, bonus: 8 },
        },
        {
            level: 9,
            extreme: { diceCount: 2, diceSize: 12, original: "2d12+17", average: 30, bonus: 17 },
            high: { diceCount: 2, diceSize: 10, original: "2d10+13", average: 24, bonus: 13 },
            moderate: { diceCount: 2, diceSize: 8, original: "2d8+11", average: 20, bonus: 11 },
            low: { diceCount: 2, diceSize: 6, original: "2d6+9", average: 16, bonus: 9 },
        },
        {
            level: 10,
            extreme: { diceCount: 2, diceSize: 12, original: "2d12+20", average: 33, bonus: 20 },
            high: { diceCount: 2, diceSize: 12, original: "2d12+13", average: 26, bonus: 13 },
            moderate: { diceCount: 2, diceSize: 10, original: "2d10+11", average: 22, bonus: 11 },
            low: { diceCount: 2, diceSize: 6, original: "2d6+10", average: 17, bonus: 10 },
        },
        {
            level: 11,
            extreme: { diceCount: 2, diceSize: 12, original: "2d12+22", average: 35, bonus: 22 },
            high: { diceCount: 2, diceSize: 12, original: "2d12+15", average: 28, bonus: 15 },
            moderate: { diceCount: 2, diceSize: 10, original: "2d10+12", average: 23, bonus: 12 },
            low: { diceCount: 2, diceSize: 8, original: "2d8+10", average: 19, bonus: 10 },
        },
        {
            level: 12,
            extreme: { diceCount: 3, diceSize: 12, original: "3d12+19", average: 38.5, bonus: 19 },
            high: { diceCount: 3, diceSize: 10, original: "3d10+14", average: 30.5, bonus: 14 },
            moderate: { diceCount: 3, diceSize: 8, original: "3d8+12", average: 25.5, bonus: 12 },
            low: { diceCount: 3, diceSize: 6, original: "3d6+10", average: 20.5, bonus: 10 },
        },
        {
            level: 13,
            extreme: { diceCount: 3, diceSize: 12, original: "3d12+21", average: 40.5, bonus: 21 },
            high: { diceCount: 3, diceSize: 10, original: "3d10+16", average: 32.5, bonus: 16 },
            moderate: { diceCount: 3, diceSize: 8, original: "3d8+14", average: 27.5, bonus: 14 },
            low: { diceCount: 3, diceSize: 6, original: "3d6+11", average: 21.5, bonus: 11 },
        },
        {
            level: 14,
            extreme: { diceCount: 3, diceSize: 12, original: "3d12+24", average: 43.5, bonus: 24 },
            high: { diceCount: 3, diceSize: 10, original: "3d10+18", average: 34.5, bonus: 18 },
            moderate: { diceCount: 3, diceSize: 8, original: "3d8+15", average: 28.5, bonus: 15 },
            low: { diceCount: 3, diceSize: 6, original: "3d6+13", average: 23.5, bonus: 13 },
        },
        {
            level: 15,
            extreme: { diceCount: 3, diceSize: 12, original: "3d12+26", average: 45.5, bonus: 26 },
            high: { diceCount: 3, diceSize: 12, original: "3d12+17", average: 36.5, bonus: 17 },
            moderate: { diceCount: 3, diceSize: 10, original: "3d10+14", average: 30.5, bonus: 14 },
            low: { diceCount: 3, diceSize: 6, original: "3d6+14", average: 24.5, bonus: 14 },
        },
        {
            level: 16,
            extreme: { diceCount: 3, diceSize: 12, original: "3d12+29", average: 48.5, bonus: 29 },
            high: { diceCount: 3, diceSize: 12, original: "3d12+18", average: 37.5, bonus: 18 },
            moderate: { diceCount: 3, diceSize: 10, original: "3d10+15", average: 31.5, bonus: 15 },
            low: { diceCount: 3, diceSize: 6, original: "3d6+15", average: 25.5, bonus: 15 },
        },
        {
            level: 17,
            extreme: { diceCount: 3, diceSize: 12, original: "3d12+31", average: 50.5, bonus: 31 },
            high: { diceCount: 3, diceSize: 12, original: "3d12+19", average: 38.5, bonus: 19 },
            moderate: { diceCount: 3, diceSize: 10, original: "3d10+16", average: 32.5, bonus: 16 },
            low: { diceCount: 3, diceSize: 6, original: "3d6+16", average: 26.5, bonus: 16 },
        },
        {
            level: 18,
            extreme: { diceCount: 3, diceSize: 12, original: "3d12+34", average: 53.5, bonus: 34 },
            high: { diceCount: 3, diceSize: 12, original: "3d12+20", average: 39.5, bonus: 20 },
            moderate: { diceCount: 3, diceSize: 10, original: "3d10+17", average: 33.5, bonus: 17 },
            low: { diceCount: 3, diceSize: 6, original: "3d6+17", average: 27.5, bonus: 17 },
        },
        {
            level: 19,
            extreme: { diceCount: 4, diceSize: 12, original: "4d12+29", average: 55, bonus: 29 },
            high: { diceCount: 4, diceSize: 10, original: "4d10+20", average: 42, bonus: 20 },
            moderate: { diceCount: 4, diceSize: 8, original: "4d8+17", average: 35, bonus: 17 },
            low: { diceCount: 4, diceSize: 6, original: "4d6+14", average: 28, bonus: 14 },
        },
        {
            level: 20,
            extreme: { diceCount: 4, diceSize: 12, original: "4d12+32", average: 58, bonus: 32 },
            high: { diceCount: 4, diceSize: 10, original: "4d10+22", average: 44, bonus: 22 },
            moderate: { diceCount: 4, diceSize: 8, original: "4d8+19", average: 37, bonus: 19 },
            low: { diceCount: 4, diceSize: 6, original: "4d6+15", average: 29, bonus: 15 },
        },
        {
            level: 21,
            extreme: { diceCount: 4, diceSize: 12, original: "4d12+34", average: 60, bonus: 34 },
            high: { diceCount: 4, diceSize: 10, original: "4d10+24", average: 46, bonus: 24 },
            moderate: { diceCount: 4, diceSize: 8, original: "4d8+20", average: 38, bonus: 20 },
            low: { diceCount: 4, diceSize: 6, original: "4d6+17", average: 31, bonus: 17 },
        },
        {
            level: 22,
            extreme: { diceCount: 4, diceSize: 12, original: "4d12+37", average: 63, bonus: 37 },
            high: { diceCount: 4, diceSize: 10, original: "4d10+26", average: 48, bonus: 26 },
            moderate: { diceCount: 4, diceSize: 8, original: "4d8+22", average: 40, bonus: 22 },
            low: { diceCount: 4, diceSize: 6, original: "4d6+18", average: 32, bonus: 18 },
        },
        {
            level: 23,
            extreme: { diceCount: 4, diceSize: 12, original: "4d12+39", average: 65, bonus: 39 },
            high: { diceCount: 4, diceSize: 12, original: "4d12+24", average: 50, bonus: 24 },
            moderate: { diceCount: 4, diceSize: 10, original: "4d10+20", average: 42, bonus: 20 },
            low: { diceCount: 4, diceSize: 6, original: "4d6+19", average: 33, bonus: 19 },
        },
        {
            level: 24,
            extreme: { diceCount: 4, diceSize: 12, original: "4d12+42", average: 68, bonus: 42 },
            high: { diceCount: 4, diceSize: 12, original: "4d12+26", average: 52, bonus: 26 },
            moderate: { diceCount: 4, diceSize: 10, original: "4d10+22", average: 44, bonus: 22 },
            low: { diceCount: 4, diceSize: 6, original: "4d6+21", average: 35, bonus: 21 },
        },
    ],
    areaDamage: [
        {
            limited: { diceCount: 1, diceSize: 6, original: "1d6", average: 3.5, bonus: 0 },
            unlimited: { diceCount: 1, diceSize: 4, original: "1d4", average: 2.5, bonus: 0 },
            level: -1,
        },
        {
            limited: { diceCount: 1, diceSize: 10, original: "1d10", average: 5.5, bonus: 0 },
            unlimited: { diceCount: 1, diceSize: 6, original: "1d6", average: 3.5, bonus: 0 },
            level: 0,
        },
        {
            limited: { diceCount: 2, diceSize: 6, original: "2d6", average: 7, bonus: 0 },
            unlimited: { diceCount: 2, diceSize: 4, original: "2d4", average: 5, bonus: 0 },
            level: 1,
        },
        {
            limited: { diceCount: 3, diceSize: 6, original: "3d6", average: 10.5, bonus: 0 },
            unlimited: { diceCount: 2, diceSize: 6, original: "2d6", average: 7, bonus: 0 },
            level: 2,
        },
        {
            limited: { diceCount: 4, diceSize: 6, original: "4d6", average: 14, bonus: 0 },
            unlimited: { diceCount: 2, diceSize: 8, original: "2d8", average: 9, bonus: 0 },
            level: 3,
        },
        {
            limited: { diceCount: 5, diceSize: 6, original: "5d6", average: 17.5, bonus: 0 },
            unlimited: { diceCount: 3, diceSize: 6, original: "3d6", average: 10.5, bonus: 0 },
            level: 4,
        },
        {
            limited: { diceCount: 6, diceSize: 6, original: "6d6", average: 21, bonus: 0 },
            unlimited: { diceCount: 2, diceSize: 10, original: "2d10", average: 11, bonus: 0 },
            level: 5,
        },
        {
            limited: { diceCount: 7, diceSize: 6, original: "7d6", average: 24.5, bonus: 0 },
            unlimited: { diceCount: 4, diceSize: 6, original: "4d6", average: 14, bonus: 0 },
            level: 6,
        },
        {
            limited: { diceCount: 8, diceSize: 6, original: "8d6", average: 28, bonus: 0 },
            unlimited: { diceCount: 4, diceSize: 6, original: "4d6", average: 14, bonus: 0 },
            level: 7,
        },
        {
            limited: { diceCount: 9, diceSize: 6, original: "9d6", average: 31.5, bonus: 0 },
            unlimited: { diceCount: 5, diceSize: 6, original: "5d6", average: 17.5, bonus: 0 },
            level: 8,
        },
        {
            limited: { diceCount: 10, diceSize: 6, original: "10d6", average: 35, bonus: 0 },
            unlimited: { diceCount: 5, diceSize: 6, original: "5d6", average: 17.5, bonus: 0 },
            level: 9,
        },
        {
            limited: { diceCount: 11, diceSize: 6, original: "11d6", average: 38.5, bonus: 0 },
            unlimited: { diceCount: 6, diceSize: 6, original: "6d6", average: 21, bonus: 0 },
            level: 10,
        },
        {
            limited: { diceCount: 12, diceSize: 6, original: "12d6", average: 42, bonus: 0 },
            unlimited: { diceCount: 6, diceSize: 6, original: "6d6", average: 21, bonus: 0 },
            level: 11,
        },
        {
            limited: { diceCount: 13, diceSize: 6, original: "13d6", average: 45.5, bonus: 0 },
            unlimited: { diceCount: 5, diceSize: 8, original: "5d8", average: 22.5, bonus: 0 },
            level: 12,
        },
        {
            limited: { diceCount: 14, diceSize: 6, original: "14d6", average: 49, bonus: 0 },
            unlimited: { diceCount: 7, diceSize: 6, original: "7d6", average: 24.5, bonus: 0 },
            level: 13,
        },
        {
            limited: { diceCount: 15, diceSize: 6, original: "15d6", average: 52.5, bonus: 0 },
            unlimited: { diceCount: 4, diceSize: 12, original: "4d12", average: 26, bonus: 0 },
            level: 14,
        },
        {
            limited: { diceCount: 16, diceSize: 6, original: "16d6", average: 56, bonus: 0 },
            unlimited: { diceCount: 8, diceSize: 6, original: "8d6", average: 28, bonus: 0 },
            level: 15,
        },
        {
            limited: { diceCount: 17, diceSize: 6, original: "17d6", average: 59.5, bonus: 0 },
            unlimited: { diceCount: 8, diceSize: 6, original: "8d6", average: 28, bonus: 0 },
            level: 16,
        },
        {
            limited: { diceCount: 18, diceSize: 6, original: "18d6", average: 63, bonus: 0 },
            unlimited: { diceCount: 8, diceSize: 6, original: "8d6", average: 28, bonus: 0 },
            level: 17,
        },
        {
            limited: { diceCount: 19, diceSize: 6, original: "19d6", average: 66.5, bonus: 0 },
            unlimited: { diceCount: 9, diceSize: 6, original: "9d6", average: 31.5, bonus: 0 },
            level: 18,
        },
        {
            limited: { diceCount: 20, diceSize: 6, original: "20d6", average: 70, bonus: 0 },
            unlimited: { diceCount: 9, diceSize: 6, original: "9d6", average: 31.5, bonus: 0 },
            level: 19,
        },
        {
            limited: { diceCount: 21, diceSize: 6, original: "21d6", average: 73.5, bonus: 0 },
            unlimited: { diceCount: 6, diceSize: 10, original: "6d10", average: 33, bonus: 0 },
            level: 20,
        },
        {
            limited: { diceCount: 22, diceSize: 6, original: "22d6", average: 77, bonus: 0 },
            unlimited: { diceCount: 10, diceSize: 6, original: "10d6", average: 35, bonus: 0 },
            level: 21,
        },
        {
            limited: { diceCount: 23, diceSize: 6, original: "23d6", average: 80.5, bonus: 0 },
            unlimited: { diceCount: 8, diceSize: 8, original: "8d8", average: 36, bonus: 0 },
            level: 22,
        },
        {
            limited: { diceCount: 24, diceSize: 6, original: "24d6", average: 84, bonus: 0 },
            unlimited: { diceCount: 11, diceSize: 6, original: "11d6", average: 38.5, bonus: 0 },
            level: 23,
        },
        {
            limited: { diceCount: 25, diceSize: 6, original: "25d6", average: 87.5, bonus: 0 },
            unlimited: { diceCount: 11, diceSize: 6, original: "11d6", average: 38.5, bonus: 0 },
            level: 24,
        },
    ],
    difficultyClass: [
        { level: -1, extreme: 19, high: 16, moderate: 13 },
        { level: 0, extreme: 19, high: 16, moderate: 13 },
        { level: 1, extreme: 20, high: 17, moderate: 14 },
        { level: 2, extreme: 22, high: 18, moderate: 15 },
        { level: 3, extreme: 23, high: 20, moderate: 17 },
        { level: 4, extreme: 25, high: 21, moderate: 18 },
        { level: 5, extreme: 26, high: 22, moderate: 19 },
        { level: 6, extreme: 27, high: 24, moderate: 21 },
        { level: 7, extreme: 29, high: 25, moderate: 22 },
        { level: 8, extreme: 30, high: 26, moderate: 23 },
        { level: 9, extreme: 32, high: 28, moderate: 25 },
        { level: 10, extreme: 33, high: 29, moderate: 26 },
        { level: 11, extreme: 34, high: 30, moderate: 27 },
        { level: 12, extreme: 36, high: 32, moderate: 29 },
        { level: 13, extreme: 37, high: 33, moderate: 30 },
        { level: 14, extreme: 39, high: 34, moderate: 31 },
        { level: 15, extreme: 40, high: 36, moderate: 33 },
        { level: 16, extreme: 41, high: 37, moderate: 34 },
        { level: 17, extreme: 43, high: 38, moderate: 35 },
        { level: 18, extreme: 44, high: 40, moderate: 37 },
        { level: 19, extreme: 46, high: 41, moderate: 38 },
        { level: 20, extreme: 47, high: 42, moderate: 39 },
        { level: 21, extreme: 48, high: 44, moderate: 41 },
        { level: 22, extreme: 50, high: 45, moderate: 42 },
        { level: 23, extreme: 51, high: 46, moderate: 43 },
        { level: 24, extreme: 52, high: 48, moderate: 45 },
    ],
    spell: [
        { level: -1, extreme: 11, high: 8, moderate: 5 },
        { level: 0, extreme: 11, high: 8, moderate: 5 },
        { level: 1, extreme: 12, high: 9, moderate: 6 },
        { level: 2, extreme: 14, high: 10, moderate: 7 },
        { level: 3, extreme: 15, high: 12, moderate: 9 },
        { level: 4, extreme: 17, high: 13, moderate: 10 },
        { level: 5, extreme: 18, high: 14, moderate: 11 },
        { level: 6, extreme: 19, high: 16, moderate: 13 },
        { level: 7, extreme: 21, high: 17, moderate: 14 },
        { level: 8, extreme: 22, high: 18, moderate: 15 },
        { level: 9, extreme: 24, high: 20, moderate: 17 },
        { level: 10, extreme: 25, high: 21, moderate: 18 },
        { level: 11, extreme: 26, high: 22, moderate: 19 },
        { level: 12, extreme: 28, high: 24, moderate: 21 },
        { level: 13, extreme: 29, high: 25, moderate: 22 },
        { level: 14, extreme: 31, high: 26, moderate: 23 },
        { level: 15, extreme: 32, high: 28, moderate: 25 },
        { level: 16, extreme: 33, high: 29, moderate: 26 },
        { level: 17, extreme: 35, high: 30, moderate: 27 },
        { level: 18, extreme: 36, high: 32, moderate: 29 },
        { level: 19, extreme: 38, high: 33, moderate: 30 },
        { level: 20, extreme: 39, high: 34, moderate: 31 },
        { level: 21, extreme: 40, high: 36, moderate: 33 },
        { level: 22, extreme: 42, high: 37, moderate: 34 },
        { level: 23, extreme: 43, high: 38, moderate: 35 },
        { level: 24, extreme: 44, high: 40, moderate: 37 },
    ],
    resistance: [
        { level: -1, maximum: 1, minimum: 1 },
        { level: 0, maximum: 3, minimum: 1 },
        { level: 1, maximum: 3, minimum: 2 },
        { level: 2, maximum: 5, minimum: 2 },
        { level: 3, maximum: 6, minimum: 3 },
        { level: 4, maximum: 7, minimum: 4 },
        { level: 5, maximum: 8, minimum: 4 },
        { level: 6, maximum: 9, minimum: 5 },
        { level: 7, maximum: 10, minimum: 5 },
        { level: 8, maximum: 11, minimum: 6 },
        { level: 9, maximum: 12, minimum: 6 },
        { level: 10, maximum: 13, minimum: 7 },
        { level: 11, maximum: 14, minimum: 7 },
        { level: 12, maximum: 15, minimum: 8 },
        { level: 13, maximum: 16, minimum: 8 },
        { level: 14, maximum: 17, minimum: 9 },
        { level: 15, maximum: 18, minimum: 9 },
        { level: 16, maximum: 19, minimum: 9 },
        { level: 17, maximum: 19, minimum: 10 },
        { level: 18, maximum: 20, minimum: 10 },
        { level: 19, maximum: 21, minimum: 11 },
        { level: 20, maximum: 22, minimum: 11 },
        { level: 21, maximum: 23, minimum: 12 },
        { level: 22, maximum: 24, minimum: 12 },
        { level: 23, maximum: 25, minimum: 13 },
        { level: 24, maximum: 26, minimum: 13 },
    ],
    weakness: [
        { level: -1, maximum: 1, minimum: 1 },
        { level: 0, maximum: 3, minimum: 1 },
        { level: 1, maximum: 3, minimum: 2 },
        { level: 2, maximum: 5, minimum: 2 },
        { level: 3, maximum: 6, minimum: 3 },
        { level: 4, maximum: 7, minimum: 4 },
        { level: 5, maximum: 8, minimum: 4 },
        { level: 6, maximum: 9, minimum: 5 },
        { level: 7, maximum: 10, minimum: 5 },
        { level: 8, maximum: 11, minimum: 6 },
        { level: 9, maximum: 12, minimum: 6 },
        { level: 10, maximum: 13, minimum: 7 },
        { level: 11, maximum: 14, minimum: 7 },
        { level: 12, maximum: 15, minimum: 8 },
        { level: 13, maximum: 16, minimum: 8 },
        { level: 14, maximum: 17, minimum: 9 },
        { level: 15, maximum: 18, minimum: 9 },
        { level: 16, maximum: 19, minimum: 9 },
        { level: 17, maximum: 19, minimum: 10 },
        { level: 18, maximum: 20, minimum: 10 },
        { level: 19, maximum: 21, minimum: 11 },
        { level: 20, maximum: 22, minimum: 11 },
        { level: 21, maximum: 23, minimum: 12 },
        { level: 22, maximum: 24, minimum: 12 },
        { level: 23, maximum: 25, minimum: 13 },
        { level: 24, maximum: 26, minimum: 13 },
    ],
    hazarddefense: [
        { level: -1, eac: 18, hac: 15, lac: 12, esave: 9, hsave: 8, lsave: 2, hardness: "2-4", hpmin: 11 },
        { level: 0, eac: 19, hac: 16, lac: 13, esave: 10, hsave: 9, lsave: 3, hardness: "3-5", hitPoints: "15-17" },
        { level: 1, eac: 19, hac: 16, lac: 13, esave: 11, hsave: 10, lsave: 4, hardness: "5-7", hitPoints: "23-25" },
        { level: 2, eac: 21, hac: 18, lac: 15, esave: 12, hsave: 11, lsave: 5, hardness: "7-9", hitPoints: "30-34" },
        { level: 3, eac: 22, hac: 19, lac: 16, esave: 14, hsave: 12, lsave: 6, hardness: "10-12", hitPoints: "42-46" },
        { level: 4, eac: 24, hac: 21, lac: 18, esave: 15, hsave: 14, lsave: 8, hardness: "11-13", hitPoints: "46-50" },
        { level: 5, eac: 25, hac: 22, lac: 19, esave: 17, hsave: 15, lsave: 9, hardness: "12-14", hitPoints: "50-54" },
        { level: 6, eac: 27, hac: 24, lac: 21, esave: 18, hsave: 17, lsave: 11, hardness: "13-15", hitPoints: "54-58" },
        { level: 7, eac: 28, hac: 25, lac: 22, esave: 20, hsave: 18, lsave: 12, hardness: "14-16", hitPoints: "58-62" },
        { level: 8, eac: 30, hac: 27, lac: 24, esave: 21, hsave: 19, lsave: 13, hardness: "15-17", hitPoints: "62-66" },
        { level: 9, eac: 31, hac: 28, lac: 25, esave: 23, hsave: 21, lsave: 15, hardness: "16-18", hitPoints: "66-70" },
        {
            level: 10,
            eac: 33,
            hac: 30,
            lac: 27,
            esave: 24,
            hsave: 22,
            lsave: 16,
            hardness: "17-19",
            hitPoints: "70-74",
        },
        {
            level: 11,
            eac: 34,
            hac: 31,
            lac: 28,
            esave: 26,
            hsave: 24,
            lsave: 18,
            hardness: "19-21",
            hitPoints: "78-82",
        },
        {
            level: 12,
            eac: 36,
            hac: 33,
            lac: 30,
            esave: 27,
            hsave: 25,
            lsave: 19,
            hardness: "20-22",
            hitPoints: "82-86",
        },
        {
            level: 13,
            eac: 37,
            hac: 34,
            lac: 31,
            esave: 29,
            hsave: 26,
            lsave: 20,
            hardness: "21-23",
            hitPoints: "86-90",
        },
        {
            level: 14,
            eac: 39,
            hac: 36,
            lac: 33,
            esave: 30,
            hsave: 28,
            lsave: 22,
            hardness: "22-24",
            hitPoints: "90-94",
        },
        {
            level: 15,
            eac: 40,
            hac: 37,
            lac: 34,
            esave: 32,
            hsave: 29,
            lsave: 23,
            hardness: "23-25",
            hitPoints: "94-98",
        },
        {
            level: 16,
            eac: 42,
            hac: 39,
            lac: 36,
            esave: 33,
            hsave: 30,
            lsave: 25,
            hardness: "25-27",
            hitPoints: "101-107",
        },
        {
            level: 17,
            eac: 43,
            hac: 40,
            lac: 37,
            esave: 35,
            hsave: 32,
            lsave: 26,
            hardness: "27-29",
            hitPoints: "109-115",
        },
        {
            level: 18,
            eac: 45,
            hac: 42,
            lac: 39,
            esave: 36,
            hsave: 33,
            lsave: 27,
            hardness: "29-31",
            hitPoints: "117-123",
        },
        {
            level: 19,
            eac: 46,
            hac: 43,
            lac: 40,
            esave: 38,
            hsave: 35,
            lsave: 29,
            hardness: "31-33",
            hitPoints: "125-131",
        },
        {
            level: 20,
            eac: 48,
            hac: 45,
            lac: 42,
            esave: 39,
            hsave: 36,
            lsave: 30,
            hardness: "33-35",
            hitPoints: "133-139",
        },
        {
            level: 21,
            eac: 49,
            hac: 46,
            lac: 43,
            esave: 41,
            hsave: 38,
            lsave: 32,
            hardness: "36-38",
            hitPoints: "144-152",
        },
        {
            level: 22,
            eac: 51,
            hac: 48,
            lac: 45,
            esave: 43,
            hsave: 39,
            lsave: 33,
            hardness: "39-41",
            hitPoints: "156-164",
        },
        {
            level: 23,
            eac: 52,
            hac: 49,
            lac: 46,
            esave: 44,
            hsave: 40,
            lsave: 34,
            hardness: "44-46",
            hitPoints: "168-176",
        },
        {
            level: 24,
            eac: 54,
            hac: 51,
            lac: 48,
            esave: 46,
            hsave: 42,
            lsave: 36,
            hardness: "46-50",
            hitPoints: "180-188",
        },
    ],
    hazardoffense: [
        { level: -1, satk: 10, catk: 8, simpledmg: "2d4+1", complexdmg: "1d4+1", edc: 19, hdc: 16 },
        { level: 0, satk: 11, catk: 8, simpledmg: "2d6+3", complexdmg: "1d6+2", edc: 19, hdc: 16 },
        { level: 1, satk: 13, catk: 9, simpledmg: "2d6+5", complexdmg: "1d6+3", edc: 20, hdc: 17 },
        { level: 2, satk: 14, catk: 11, simpledmg: "2d10+7", complexdmg: "1d10+4", edc: 22, hdc: 18 },
        { level: 3, satk: 16, catk: 12, simpledmg: "2d10+13", complexdmg: "1d10+6", edc: 23, hdc: 20 },
        { level: 4, satk: 17, catk: 14, simpledmg: "4d8+10", complexdmg: "2d8+5", edc: 25, hdc: 21 },
        { level: 5, satk: 19, catk: 15, simpledmg: "4d8+14", complexdmg: "2d8+7", edc: 26, hdc: 22 },
        { level: 6, satk: 20, catk: 17, simpledmg: "4d8+18", complexdmg: "2d8+9", edc: 27, hdc: 24 },
        { level: 7, satk: 22, catk: 18, simpledmg: "4d10+18", complexdmg: "2d10+9", edc: 29, hdc: 25 },
        { level: 8, satk: 23, catk: 20, simpledmg: "4d10+22", complexdmg: "2d10+11", edc: 30, hdc: 26 },
        { level: 9, satk: 25, catk: 21, simpledmg: "4d10+26", complexdmg: "2d10+13", edc: 32, hdc: 28 },
        { level: 10, satk: 26, catk: 23, simpledmg: "4d12+26", complexdmg: "2d12+13", edc: 33, hdc: 29 },
        { level: 11, satk: 28, catk: 24, simpledmg: "4d12+30", complexdmg: "2d12+15", edc: 34, hdc: 30 },
        { level: 12, satk: 29, catk: 26, simpledmg: "6d10+27", complexdmg: "3d10+14", edc: 36, hdc: 32 },
        { level: 13, satk: 31, catk: 27, simpledmg: "6d10+31", complexdmg: "3d10+16", edc: 37, hdc: 33 },
        { level: 14, satk: 32, catk: 29, simpledmg: "6d10+35", complexdmg: "3d10+18", edc: 39, hdc: 34 },
        { level: 15, satk: 34, catk: 30, simpledmg: "6d12+33", complexdmg: "3d12+17", edc: 40, hdc: 36 },
        { level: 16, satk: 35, catk: 32, simpledmg: "6d12+35", complexdmg: "3d12+18", edc: 41, hdc: 37 },
        { level: 17, satk: 37, catk: 33, simpledmg: "6d12+37", complexdmg: "3d12+19", edc: 43, hdc: 38 },
        { level: 18, satk: 38, catk: 35, simpledmg: "6d12+41", complexdmg: "3d12+20", edc: 44, hdc: 40 },
        { level: 19, satk: 40, catk: 36, simpledmg: "8d10+40", complexdmg: "4d10+20", edc: 46, hdc: 41 },
        { level: 20, satk: 41, catk: 38, simpledmg: "8d10+44", complexdmg: "4d10+22", edc: 47, hdc: 42 },
        { level: 21, satk: 43, catk: 39, simpledmg: "8d10+48", complexdmg: "4d10+24", edc: 48, hdc: 44 },
        { level: 22, satk: 44, catk: 41, simpledmg: "8d10+52", complexdmg: "4d10+26", edc: 50, hdc: 45 },
        { level: 23, satk: 46, catk: 42, simpledmg: "8d12+48", complexdmg: "4d12+24", edc: 51, hdc: 46 },
        { level: 24, satk: 47, catk: 44, simpledmg: "8d12+52", complexdmg: "4d12+26", edc: 52, hdc: 48 },
    ],
    level: [-1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
};
